<div mat-dialog-content>
  <div>
    <h1 class="text-center">Some files couldn't be uploaded</h1>
    <p class="text-center">{{data.fileList.length}} out of {{data.allFiles}} files has been detected to be non-DICOM and have been skipped.</p>
  </div>
  <mat-list>
    <mat-list-item *ngFor="let file of data.fileList">
      <div class="file-icon-container">
        <img src="./assets/ui/png/borken_pdf_file.png" class="file-icon">
      </div>
      <div mat-line>{{file}}</div>
    </mat-list-item>
  </mat-list>
</div>
<mat-dialog-actions>
  <button mat-dialog-close class="button-blueGDPR m-auto">Close</button>
</mat-dialog-actions>
